import React, { useImperativeHandle, useEffect, useMemo } from "react";
import ShopType from "@/enum/ShopType";
import { useGlobalStore } from "@/store/hooks";
import { selectSpecificShopType } from "@/utils";
import { Form, FormInstance, Select } from "antd";
import { observer } from "mobx-react-lite";

interface SelectManualShopFormProps {}

interface SelectManualShopFormValues {
    shopId: number;
}

export interface SelectManualShopFormInstance extends FormInstance<SelectManualShopFormValues> {}

const SelectManualShopForm: React.ForwardRefRenderFunction<SelectManualShopFormInstance, SelectManualShopFormProps> =
    function (props, ref) {
        const { allowedShops } = useGlobalStore();

        const [form] = Form.useForm<SelectManualShopFormValues>();

        const manualShops = useMemo(() => selectSpecificShopType(allowedShops, [ShopType.MANUAL]), [allowedShops]);

        useEffect(() => {
            if (manualShops.length === 1) {
                form.setFieldsValue({ shopId: manualShops[0]?.id });
            }
        }, [manualShops]);

        useImperativeHandle(ref, () => form);

        return (
            <Form form={form}>
                <Form.Item label="选择手工订单录入的店铺：" name="shopId" rules={[{ required: true }]}>
                    <Select
                        style={{ width: 300 }}
                        options={[...(manualShops.map(shop => {
                          return {
                            value: shop.id,
                            key: shop.id,
                            label: shop.name
                          };
                        }) ?? [])]}
                    />
                </Form.Item>
            </Form>
        );
    };

export default React.memo(observer(React.forwardRef(SelectManualShopForm)));
